import caffe from "./caffe";
import cerbiatto from "./cerbiatto";
import cortile from "./cortile";
import fiori from "./fiori";
import motociclo from "./motociclo";
import te from "./te";
import volpe from "./volpe";

export default [caffe, cerbiatto, cortile, fiori, motociclo, te, volpe];
